<ng-container *ngIf="size === 'medium'">
  <div class="copy_cell" [ngClass]="{'copy_cell--show-border':border}">
    <div class="flex-row space-between">
      <typography-legacy *ngIf="color === 'primary'" text-medium-regular>{{label}}</typography-legacy>
      <typography-legacy *ngIf="color === 'secondary'" text-medium-regular color="var(--secondary-text)">{{label}}</typography-legacy>
      <div class="copy-cell__details flex-row" (click)="cellClicked()">
        <typography-legacy text-medium-regular><div [innerHTML]="detail"></div></typography-legacy>
        <bw-icon-legacy *ngIf="iconName" [iconName]="iconName"></bw-icon-legacy>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="size === 'small'">
  <div class="copy_cell" [ngClass]="{'copy_cell--show-border':border}">
    <div class="flex-row space-between">
      <typography-legacy *ngIf="color === 'primary'" text-small-regular>{{label}}</typography-legacy>
      <typography-legacy *ngIf="color === 'secondary'" text-small-regular color="var(--secondary-text)">{{label}}</typography-legacy>
      <div class="copy-cell__details flex-row" (click)="cellClicked()">
        <typography-legacy text-small-regular><div [innerHTML]="detail"></div></typography-legacy>
        <bw-icon-legacy *ngIf="iconName" [iconName]="iconName"></bw-icon-legacy>
      </div>
    </div>
  </div>
</ng-container>

